import { Injectable } from "@angular/core";
import { InteractionService } from "~/app/core/interaction.service";
import { RPCService } from "~/app/core/rpc.service";
import * as Log from "~/app/core/log";
import { InteractionAggregate } from "~/app/core/model/interaction/interaction-aggregate";
import { StorageService } from "~/app/core/storage.service";
import { NetworkService } from "~/app/core/network.service";
import { LocationService } from "~/app/core/location.service";
import { Observable, Subject } from "rxjs";

let sharedSuspendServiceInstance: SuspendService = null;

export function sharedSuspendService(): SuspendService {
    return sharedSuspendServiceInstance;
}

export type SuspendStatus = "suspend"|"resume";

@Injectable()
export class SuspendService {
    private statusMessages: Subject<SuspendStatus> = new Subject<SuspendStatus>();

    constructor(
        private readonly interactionService: InteractionService,
        private readonly storageService: StorageService,
        private readonly networkService: NetworkService,
        private readonly locationService: LocationService,
        private readonly rpc: RPCService
    ) {
        // do nothing
        sharedSuspendServiceInstance = this;
    }

    statusObservable(): Observable<SuspendStatus> {
        return this.statusMessages;
    }

    updateStatus(status: SuspendStatus) {
        this.statusMessages.next(status);
    }

    transmitInteractions() {
        Log.debug(Log.Tag.SuspendService, "Transmit interactions");
        const aggr: InteractionAggregate = this.storageService.loadInteraction();
        if (aggr.other || aggr.offers || aggr.ads) {
            this.rpc.InteractionAggregate_queue(aggr);
            this.storageService.storeInteraction(null);
            this.rpc.flushAsync();
        }
    }

    pauseTimers() {
        this.interactionService.pauseTimers();
    }

    pauseLocation() {
        this.locationService.pauseLocation();
    }

    resumeTimers() {
        this.interactionService.resumeTimers();
    }

    resumeLocation() {
        this.locationService.resumeLocation();
    }
}
